<template>
    <transition :name="direction">
        <div v-show="visibleSlide === index">
            <slot></slot>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'Carousel4Slide',
    props: [
        'visibleSlide',
        'index',
        'direction',
    ],
}
</script>

<style lang="scss" scoped>
    .left-enter-active {
        animation: leftInAnimation 1.2s ease-in-out;
    }
    .left-leave-active {
        animation: leftOutAnimation 1.2s ease-in-out;
    }
    @keyframes leftInAnimation {
        from { transform: translateX(100%); }
        to { transform: translateX(0); }
    }
    @keyframes leftOutAnimation {
        from { transform: translateX(0); }
        to { transform: translateX(-100%); }
    }
    .right-enter-active {
        animation: rightInAnimation 1.2s ease-in-out;
    }
    .right-leave-active {
        animation: rightOutAnimation 1.2s ease-in-out;
    }
    @keyframes rightInAnimation {
        from { transform: translateX(-100%); }
        to { transform: translateX(0); }
    }
    @keyframes rightOutAnimation {
        from { transform: translateX(0); }
        to { transform: translateX(100%); }
    }
</style>
